export const STUB_FN_FALSE = () => false;
export const STUB_FN_TRUE = () => true;
export const STUB_FN_STRING = () => ``;
export const STUB_FN_ZERO = () => 0;
export const STUB_FN_NULL = () => null;
export const STUB_FN_RESOLVER = () => Promise.resolve();
export const STUB_FN_REJECTER = () => Promise.reject();